import { ScoutingCenter } from '#src/components/scoutingCenter/ScoutingCenter/index.tsx';

const ScoutingCenterSo5CompetitionPage = () => {
  return <ScoutingCenter />;
};

export default ScoutingCenterSo5CompetitionPage;
